require('./restoreModal.i18n.json');
require('./restoreModal.tpl.html');
require('./restoreRepository.js');

/*@ngInject*/
const RestoreModalController = function ($rootScope, $scope, coreConstant, localization, $timeout, attachmentUtil, modalUtil, configurationMediator, loadingBarHandler) {

    localization.getTranslationByKey('restore').then(function (translations) {
        $scope.viewModel = {
            title: translations.title,
            cancelButton: translations.cancelButton,
            confirmButton: translations.confirmButton,
            or: translations.or,
            dragAndDrop: translations.dragAndDrop,
            uploadedFile: null,
            chooseFileString: translations.restoreFile,
            attachment: {},
            restoreMode: '',
            acceptedTypes: ['.dbinit', '.xml']
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.fileSelected = function (file) {
            if (file) {
                storeUploadedFile(file);
            }
        };

        $scope.onConfirm = function () {
            $scope.$close();
            loadingBarHandler.showLoadingBar(translations.loadingBar + ' ' + $scope.viewModel.attachment.name);
            configurationMediator.restore($scope.viewModel.restoreMode, $scope.viewModel.uploadedFile).then(function () {
                loadingBarHandler.hideLoadingBar();
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, translations.successMessage + ' ' + $scope.viewModel.attachment.name);
            }, function () {
                // On Error
                loadingBarHandler.hideLoadingBar();
            });
        };

        $scope.canEnableConfirmButton = function () {
            return $scope.viewModel.attachment.name && $scope.viewModel.restoreMode;
        };

        $scope.onUpdateField = function () {
            if ($scope.viewModel.attachment && $scope.viewModel.attachment.id) {
                $scope.updateAttachment($scope.viewModel.attachment);
            }
        };

        function storeUploadedFile(uploadedFile) {
            var allowFile = attachmentUtil.validateAttachmentType(uploadedFile, _.get(translations, 'unacceptableType'), $scope.viewModel.acceptedTypes);
            if (allowFile) {
                $timeout(function () {
                    $scope.viewModel.uploadedFile = uploadedFile;
                    if (!$scope.viewModel.attachment) {
                        $scope.viewModel.attachment = {};
                    }
                    $scope.viewModel.attachment.name = uploadedFile.name;
                    $scope.viewModel.attachment.size = uploadedFile.size;
                }, 0);
            }
        }

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
            if (file) {
                storeUploadedFile(file);
            }
        });

        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    });
};

angular.module('ums.configuration')
    .controller('restoreModalController', RestoreModalController);
